var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.957 0 0 .957 32.35 -11.96)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    d: "M159.52 57.562c14.774 7.221 16.838 18.702 24.026 27.09 41.164-4.905 84.404-3.03 127.285 14.074-31.041-58.024-108.855-65.172-141.058-61.728-15.736 1.614-23.878 14.276-10.253 20.564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7948",
    stroke: "none",
    d: "M386.702 417.535c43.276-67.137 60.325-138.523 38.43-205.599-35.678-8.134-23.374-5.325-26.036-5.935-31.616-7.36-58.827-3.93-80.877 10.193-39.384 25.225-54.048 77.922-58.568 99.742l-4.55 28.451c31.694 33.68 69.15 63.466 110.834 77.292 4.958 1.644 8.312 3.012 12.935 1.693a13.769 13.769 0 007.832-5.837zm-35.049-115.097c-9.981-8.84-10.388-23.422-2.124-32.752 8.277-9.346 22.802-10.676 32.77-1.849 9.554 8.463 10.44 23.069 1.977 32.623-8.462 9.555-23.068 10.44-32.623 1.978z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82afff",
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 1,
    d: "M22.697 348.888l.007.023c22.925 93.362 118.772 151.82 122.84 154.263 2.286 1.372 9.505 3.192 12.444 3.192 4.203 0 25.997-1.94 44.315-23.517 16.19-19.069 20.798-47.456 13.692-84.37-1.8-9.36-11.905-14.776-20.784-10.889-.248.108-25.14 10.836-55.493 9.697-36.467-1.373-65.663-10.737-84.958-52.573-17.128-37.138-31.37-101.383-21.944-129.726-19.233 45.874-19.898 94.036-10.12 133.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eb2448",
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 1,
    d: "M130.33 111.79c46.802-24.88 102.35-21.819 141.967-13.67 39.618 8.147 112.75 38.201 148.3 102.526-6.262-1.427-6.204-1.415-6.522-1.484-38.463-8.932-71.13-12.102-102.186 7.788-52.696 33.753-61.225 98.067-63.214 123.164-.035.455-.03.5-.249 6.752-18.116-19.108-22.127-46.135-58.886-67.8-36.76-21.663-79.525-10.205-104.864 13.816-25.338 24.02-24.712 52.784-29.918 61.835-20.27-41.372-32.846-100.779-22.049-129.546 14.555-34.38 50.82-78.5 97.621-103.38z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 362.266,
    cy: 263.286,
    fill: "none",
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.708,
    display: "inline",
    rx: 13.579,
    ry: 13.507
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeOpacity: 1,
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 276.106,
    r: 217.506,
    fillOpacity: 1,
    stroke: "#0500ff",
    strokeDasharray: "5, 10",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.276,
    cy: 312.67,
    r: 81.783,
    fillOpacity: 1,
    stroke: "#0500ff",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeWidth: 1.021,
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    d: "M98.083 313.664l168.642-.785",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    d: "M93.414 171.036l-32.083 72.896",
    display: "inline"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.068202f6e18b3216bf854438a71f6e82.svg";
export { ForwardRef as ReactComponent };